import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import RightOne from './right-one';
import RightTwoBlackouts from './right-two-blackouts';
import RightFourPickUpDropOff from './right-four-pickup-dropoff';
import Policies from './right-policies';
import R from 'ramda';

const propTypes = {
  reducerName: PropTypes.string,
  openAddEditContractDialog: PropTypes.func,
  deleteFromProduct: PropTypes.func,
  supplierEditable: PropTypes.bool,
  contractState: PropTypes.string,
  productType: PropTypes.string,
  existingSeasons: PropTypes.array,
  contractingPeriod: PropTypes.object,
  openGlobalAlert: PropTypes.func,
};
class RightColumn extends Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }

  render() {
    const {
      deleteFromProduct,
      openGlobalAlert,
      ...sharedProp,
    } = this.props;
    return (
      <div style={{ padding: '24px', paddingLeft: '0', width: '35%', float: 'right' }}>
        <RightOne {...sharedProp} />
        <RightTwoBlackouts {...sharedProp} />
        <RightFourPickUpDropOff {...sharedProp} />
        <Policies
          {...sharedProp}
          deletePolicy={policyType => {
            openGlobalAlert({
              text: 'Are you sure you want to delete this policy?',
              onOk: () => deleteFromProduct({ policyType, updateType: 'DELETE_PRODUCT_POLICY_FROM_CONTRACT' }),
            });
          }}
        />
      </div>
    );
  }
}

RightColumn.propTypes = propTypes;

const mapStateToProps = ({ contracting }, { reducerName }) => {
  const leftNav = contracting[reducerName].get('leftNav').toJS();
  const rightSideContent = contracting[reducerName].get('rightSideContent').toJS();
  const { seasons, seasonRates } = rightSideContent;
  return ({
    supplierEditable: contracting[reducerName].getIn(['leftNav', 'supplierEditable']),
    contractState: contracting[reducerName].getIn(['leftNav', 'contractState']),
    productType: contracting[reducerName].getIn(['rightSideContent', 'productType']),
    existingSeasons: ((seasonRates || []).length > (seasons || []).length ? seasonRates : seasons || []),
    contractingPeriod: leftNav.startDate && leftNav.endDate ? { startDate: new Date(leftNav.startDate), endDate: new Date(leftNav.endDate) } : {},
  });
};


const mapActions = ({
  openGlobalAlert: payload => ({
    type: 'open_global_alert',
    payload,
  }),
});
export default connect(mapStateToProps, mapActions)(RightColumn);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/right-column/right-column.jsx